import React from 'react';
import {
  Route, Redirect, Switch,
} from 'react-router-dom';
// Rediseño u original según REACT_APP_PLR_REDESIGN / ?flujo= (ver PreLoanFlowSwitch).
import PreLoanIndex from '../../pages/preloan/PreLoanFlowSwitch';

function PreloanRoutes() {
  return (
    <Route
      render={
        ({ location }) => (
          <Switch location={location}>
            <Route exact path="/preloan" component={PreLoanIndex} />
            <Route path="/">
              <Redirect to="/preloan" />
            </Route>
          </Switch>
        )
}
    />
  );
}

export default PreloanRoutes;
